import { Box, Button, Grid, Typography, useMediaQuery } from "@mui/material";
import { Theme, useTheme } from "@mui/material/styles";
import About from "./About";
import Projects from "./Projects";
import Experience from "./Experience";
import Lab from "./Lab";
import Certificates from "./Certificates";
import Contact from "./Contact";
import { Link } from "react-scroll";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import logoImage from "../assets/logo.jpg";

type HomeProps = {
  handleChangeValue: (newValue: string) => void;
};

function Home(props: HomeProps) {
  const theme = useTheme();
  const isSmScreen = useMediaQuery((responsiveTheme: Theme) =>
    responsiveTheme.breakpoints.down("sm")
  );
  const { state } = useLocation();
  const { targetId } = state || {};
  useEffect(() => {
    const el = document.getElementById(targetId);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }, [targetId]);

  return (
    <>
      <Box id="home" sx={{ height: "90vh", display: "flex", alignItems: "center" }}>
        <Grid container sx={{ textAlign: isSmScreen ? "center" : "start" }}>
          <Grid item xs={12}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1, justifyContent: isSmScreen ? "center" : "start" }}>
              <img src={logoImage} alt="Logo" style={{ width: 80, height: 80, borderRadius: "50%" }} />
              <Typography variant="h1" fontWeight={700} sx={{ padding: 0 }}>
                Hello!
              </Typography>
            </Box>
            <Typography variant="h1">
              I'm{" "}
              <span style={{ color: theme.palette.secondary.main }}>Ryan Dean</span>
              , a{" "}
              <span style={{ color: theme.palette.secondary.main }}>Game Programmer</span>
              {" "}with 8+ years of experience shipping games across Unreal, Unity, and Godot.
            </Typography>
          </Grid>
          <Grid item xs={12} sx={{ mt: 2 }}>
            <Box
              sx={{
                border: "solid 1px",
                borderColor: theme.palette.secondary.main,
                display: "inline-flex",
                alignItems: "center",
                padding: "5px 12px",
                mb: 3,
              }}
            >
              <Box
                sx={{
                  width: "12px",
                  height: "12px",
                  backgroundColor: "#4caf50",
                  borderRadius: "50%",
                  mr: 1,
                }}
              />
              <Typography variant="body2">Open to opportunities</Typography>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              gap: 2,
              justifyContent: isSmScreen ? "center" : "start",
            }}
          >
            <Link to="projects" spy smooth offset={-64} duration={500}>
              <Button
                variant="outlined"
                sx={{ borderColor: theme.palette.secondary.main }}
              >
                <span style={{ textTransform: "initial" }}>View Projects</span>
              </Button>
            </Link>
            <Button
              variant="outlined"
              sx={{ borderColor: theme.palette.secondary.main }}
              href="https://steller102-3d.vercel.app"
              target="_blank"
            >
              <span style={{ textTransform: "initial" }}>3D Portfolio</span>
            </Button>
          </Grid>
        </Grid>
      </Box>
      <div id="about">
        <About isSmallScreen={isSmScreen} />
      </div>
      <div id="experience">
        <Experience isSmallScreen={isSmScreen} />
      </div>
      <div id="projects">
        <Projects isSmallScreen={isSmScreen} />
      </div>
      <div id="lab">
        <Lab isSmallScreen={isSmScreen} />
      </div>
      <div id="certificates">
        <Certificates isSmallScreen={isSmScreen} />
      </div>
      <div id="contact">
        <Contact isSmallScreen={isSmScreen} />
      </div>
    </>
  );
}

export default Home;
